import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problem() {
  return (
    <section className="problem_amj p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center my-auto resp_order"
          >
            <div className="solution_img">
              <StaticImage
                src="../../../images/case-studies/hde/Tek_img_01.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={846}
                height={708}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={7}
            xl={6}
            xxl={6}
            className="offset-xl-1 my-auto"
          >
            <h2>The Problem</h2>
            <p>
              During the research, we identified the critical challenges in the
              industry, mainly the inherent problems of online auctions. Some of
              the problems identified by Tekevol are listed below:
            </p>
            <ul className="ul_sytle">
              <li>
                We identified a massive void between the demand and supply of
                accurately described items. Although the existing apps were
                delivering pictorial and text-based information, still
                authenticity of the product remained a concern.
              </li>
              <li>
                Finding an ideal target audience is challenging from logistics
                and financial standpoint. Sellers were required to create
                auction hypes on social media and third-party websites,
                comparatively, an expensive option.
              </li>
              <li>
                Existing platforms are not offering convenient payment methods
                to facilitate different buyers. Users of digital wallets still
                do not have full authority over participating in online
                auctions.
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problem;
